import React, { useEffect, useState } from "react";
import endpoint from "../../../auth/endpoint";
import { Link, Navigate } from "react-router-dom";
import Loader from "react-loader-advanced";
import { Form, Button, Modal } from "react-bootstrap";
import "./printCauseListWithReason.css";
import { Context } from "../../../auth/Context";
import Swal from "sweetalert2";
import "../cases/SweetAlertOverrides.css";

const CauseListWithSisterReason = () => {
  const [isLoading, setLoading] = useState(false);
  const [dailyCauseList, setDailyCauseList] = useState([]);
  const [dateFrom, setDateFrom] = useState("");
  const [attachReasonModal, setAttachReasonModal] = useState(false);
  const [dateTo, setDateTo] = useState("");

  // state for reason modal
  const [reason, setReason] = useState("");
  const [remark, setRemark] = useState("");
  const [case_diary_id, setCaseDiaryId] = useState("");

  const handleReasonSubmit = async (e) => {
    e.preventDefault();
    const result = await Swal.fire({
      title: "Are you sure?",
      text: "Do you really want to save remark?",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#28a745",
      cancelButtonColor: "#6c757d",
      confirmButtonText: "Yes!",
      customClass: {
        confirmButton: "swal2-confirm-green-text",
        cancelButton: "swal2-confirm-green-text",
      },
    });

    if (result.isConfirmed) {
      try {
        const response = await endpoint.post(
          `case-diary/save-diary-reason-and-remark`,
          { case_diary_id: case_diary_id, remark: remark, reason: reason },
        );

        if (response.status === 200) {
          setAttachReasonModal(false);
          setReason("");
          setRemark("");
          setCaseDiaryId("");
          Swal.fire(
            "Success!",
            "Reason and remark saved successfully.",
            "success",
          );
          handleFetchData(dateFrom);
        } else {
          setAttachReasonModal(false);
          setReason("");
          setRemark("");
          setCaseDiaryId("");
          Swal.fire("Failed!", "Unable to save reason and remark.", "error");
        }
      } catch (error) {
        setAttachReasonModal(false);
        setReason("");
        setRemark("");
        setCaseDiaryId("");
        console.error("Error performing save:", error);
        const message =
          error.response?.data?.message || "Something went wrong while saving.";
        Swal.fire("Error!", message, "error");
      }
    }
  };

  const dateSuffix = (day) => {
    if (day == 1 || day == 21 || day == 31) {
      return day + "" + "st";
    } else if (day == 2 || day == 22) {
      return day + "" + "nd";
    } else if (day == 3 || day == 23) {
      return day + "" + "rd";
    } else {
      return day + "" + "th";
    }
  };

  const formattedDate =
    dateFrom &&
    (
      new Date(dateFrom).toLocaleDateString("en-us", { weekday: "long" }) +
      ", " +
      dateSuffix(
        new Date(dateFrom).toLocaleDateString("en-us", { day: "numeric" }),
      ) +
      " day of " +
      new Date(dateFrom).toLocaleDateString("en-us", { month: "long" }) +
      ", " +
      new Date(dateFrom).toLocaleDateString("en-us", { year: "numeric" })
    ).toUpperCase();

  const curDate = new Date();
  const dateStr = (
    curDate.toLocaleDateString("en-us", { weekday: "long" }) +
    ", " +
    dateSuffix(curDate.toLocaleDateString("en-us", { day: "numeric" })) +
    " day of " +
    curDate.toLocaleDateString("en-us", { month: "long" }) +
    ", " +
    curDate.toLocaleDateString("en-us", { year: "numeric" })
  ).toUpperCase();

  const alphabetArray = "ABCDEFGHIJKLMNOPQRSTUVWXYZ".split("");
  const alphabetForSisterCase = "abcdefghijklmnopqrstuvwxyz".split("");

  const todaysDate = () => {
    const currentDate = new Date();
    const year = currentDate.getFullYear();
    const month = String(currentDate.getMonth() + 1).padStart(2, "0"); // Months are 0-based, so add 1
    const day = String(currentDate.getDate()).padStart(2, "0");

    const formatDate = `${year}-${month}-${day}`;

    console.log("new", formatDate);
    return formatDate;
  };

  const handleFetchData = async () => {
    setLoading(true);
    await endpoint
      .post(`/case-diary/weekly-list-by-date`, { date: dateFrom })
      .then(({ data }) => {
        console.log("response with supplied data", data.data);
        let causeArr = data.data;

        const groupedByLocation = causeArr.reduce((result, obj) => {
          const location = obj.location || "N/A"; // fallback if location is missing

          if (!result[location]) {
            result[location] = {};
          }

          const key =
            obj.CaseType.case_type +
            " " +
            obj.CaseTypeCategory.case_type_cat +
            " " +
            (obj.AdjournmentType.id == 2 ? obj.AdjournmentType.id : "");

          if (!result[location][key]) {
            result[location][key] = [];
          }

          result[location][key].push(obj);

          return result;
        }, []);
        console.log("groupedByLocation", groupedByLocation);
        setDailyCauseList(groupedByLocation);

        setLoading(false);
      })
      .catch((err) => {
        console.log(err);
        setLoading(false);
      });
  };

  /////////HANDLE SPLIT /////////

  //function that adds "judgement" to heading
  const splitHeading = (str) => {
    const firstSpaceIndex = str.indexOf(" ");
    const firstPart = str.slice(0, firstSpaceIndex);
    return (firstPart + " " + "Judgment").toUpperCase();
  };

  //function that removes the adjournment id from heading
  const removeNumber = (str) => {
    const result = str.replace(/[0-9]/g, "");
    return (result + " " + "(s)").toUpperCase();
  };

  return (
    <>
      {isLoading && (
        <div className="d-flex align-items-center justify-content-center vh-100">
          <img
            src={"/loading.gif"}
            alt={""}
            className="img-fluid"
            style={{ maxWidth: "50px" }}
          />
        </div>
      )}
      {!isLoading && (
        <div id="divToPrint">
          <div className="row mt-4">
            <div
              className="col-md-12 text-center"
              id="hideDate"
              style={{ textDecoration: `underline` }}
            >
              {" "}
              <h3>REASON FOR CAUSE LIST</h3>
              <br />
            </div>
            <div className="col">
              <label className="text-danger" id="hideDate">
                <i>
                  **Please select date and click on search to print cause list**
                </i>
              </label>
              <div className="input-group mb-3" id="hideDate">
                <input
                  type="date"
                  className="form-control"
                  aria-label="From Date"
                  aria-describedby="button-addon2"
                  value={dateFrom}
                  onChange={(e) => setDateFrom(e.target.value)}
                />
                {/* <input type="date" className="form-control" aria-label="To Date" aria-describedby="button-addon2"
                                value={dateTo}
                                onChange={(e) => setDateTo(e.target.value)}
                            /> */}
                <div className="input-group-append">
                  <button
                    className="btn btn-outline-primary"
                    type="button"
                    onClick={handleFetchData}
                    id="button-addon2"
                  >
                    Search
                  </button>
                </div>
              </div>
            </div>
            <div className="col"></div>
          </div>

          {isLoading && <Loader />}

          {!isLoading && (
            <div className="row mt-4">
              <div className="col-md-12">
                {Object.entries(dailyCauseList).map(
                  ([location, groupings], locationIndex) => {
                    // Find the first justiceAssignment in this location group
                    let firstPanel = "";

                    // loop through all case groups under this location to find a panel
                    for (const [_, cases] of Object.entries(groupings)) {
                      for (const caseItem of cases) {
                        if (
                          caseItem.justiceAssignment &&
                          caseItem.justiceAssignment.length > 0
                        ) {
                          firstPanel =
                            caseItem.justiceAssignment[0].panel || "";
                          break;
                        }
                      }
                      if (firstPanel) break;
                    }
                    return (
                      <div key={locationIndex}>
                        {/* Location Header */}
                        <div
                          className="text-center mb-4"
                          style={{
                            fontWeight: "bold",
                            fontSize: "18px",
                            textDecoration: "underline",
                          }}
                        >
                          IN THE SUPREME COURT OF NIGERIA
                          <br /> HOLDEN AT ABUJA <br /> CAUSE LIST FOR{" "}
                          {dateFrom
                            ? formattedDate
                            : dateStr.toUpperCase()}{" "}
                          <br />
                          {location.toUpperCase()}{" "}
                          {firstPanel && <span>({firstPanel})</span>}
                        </div>

                        {Object.entries(groupings)
                          .sort(([keyA], [keyB]) => {
                            const isMotionA = keyA
                              .toLowerCase()
                              .includes("motion");
                            const isMotionB = keyB
                              .toLowerCase()
                              .includes("motion");

                            if (isMotionA && !isMotionB) return -1; // Motion first
                            if (!isMotionA && isMotionB) return 1; // Appeal after Motion

                            return keyA.localeCompare(keyB); // alphabetical fallback
                          })
                          .map(([headings, items], index) => (
                            <div className="causeListHeading" key={index}>
                              <div
                                className="causeListSecondHeading text-center mb-2"
                                style={{
                                  color: `${headings.toUpperCase().includes("CIVIL") ? "green" : headings.toUpperCase().includes("CRIMINAL") ? "red" : headings.toUpperCase().includes("POLITICAL") ? "blue" : ""}`,
                                }}
                              >
                                {headings.includes(2)
                                  ? `${alphabetArray[index]}. ${splitHeading(headings)}`
                                  : `${alphabetArray[index]}. ${removeNumber(headings)}`}
                              </div>

                              <div className="table-reponsive">
                                <table
                                  className="table mb-5"
                                  style={{ width: `100%` }}
                                >
                                  <thead className="thead-light">
                                    <tr style={{ border: `1px solid black` }}>
                                      <th
                                        style={{
                                          maxWidth: `5px`,
                                          border: `1px solid black`,
                                        }}
                                      >
                                        SN.
                                      </th>
                                      <th
                                        scope="col"
                                        style={{ border: `1px solid black` }}
                                      >
                                        APPEAL NO.
                                      </th>
                                      {headings
                                        .toUpperCase()
                                        .includes("APPEAL") ? (
                                        <>
                                          <th
                                            scope="col"
                                            style={{
                                              border: `1px solid black`,
                                            }}
                                          >
                                            APPELLANTS
                                          </th>
                                          <th
                                            scope="col"
                                            style={{
                                              border: `1px solid black`,
                                            }}
                                          >
                                            RESPONDENTS
                                          </th>
                                        </>
                                      ) : (
                                        <>
                                          <th
                                            scope="col"
                                            style={{
                                              border: `1px solid black`,
                                            }}
                                          >
                                            PARTIES
                                          </th>
                                          {/* <th scope="col" style={{ border: `1px solid black` }}>APPLICATIONS</th> */}
                                        </>
                                      )}
                                      <th
                                        scope="col"
                                        style={{ border: `1px solid black` }}
                                      >
                                        REASON
                                      </th>
                                      <th
                                        scope="col"
                                        id="hideDate"
                                        style={{ border: `1px solid black` }}
                                      >
                                        ACTION
                                      </th>
                                    </tr>
                                  </thead>

                                  <tbody>
                                    {items.map((item, index) => (
                                      <>
                                        {item.CaseAttachements &&
                                          item.CaseAttachements.map(
                                            (Case, index2) => {
                                              const hasSisters =
                                                item.CaseAttachements.length >
                                                1;
                                              return (
                                                <tr
                                                  key={`${index}-${index2}`}
                                                  style={{
                                                    border: `1px solid black`,
                                                  }}
                                                >
                                                  {index2 === 0 && (
                                                    <td
                                                      rowSpan={
                                                        item.CaseAttachements
                                                          .length
                                                      }
                                                      style={{
                                                        border: `1px solid black`,
                                                      }}
                                                    >
                                                      {index + 1}.
                                                    </td>
                                                  )}
                                                  <td
                                                    style={{
                                                      border: `1px solid black`,
                                                      color: `${item.CaseType.case_color}`,
                                                    }}
                                                  >
                                                    <strong>
                                                      {" "}
                                                      {hasSisters
                                                        ? `${alphabetForSisterCase[index2]}. ${Case.suite_no}`
                                                        : Case.suite_no}
                                                    </strong>
                                                  </td>
                                                  {headings
                                                    .toUpperCase()
                                                    .includes("APPEAL") ? (
                                                    <>
                                                      <td
                                                        style={{
                                                          whiteSpace: `normal`,
                                                          border: `1px solid black`,
                                                        }}
                                                      >
                                                        <tr>
                                                          {Case.appellants}{" "}
                                                          {Case.otherAppellantCount ===
                                                          1 ? (
                                                            <>
                                                              <strong>
                                                                {" "}
                                                                & Anor{" "}
                                                              </strong>
                                                            </>
                                                          ) : Case.otherAppellantCount >
                                                            1 ? (
                                                            <>
                                                              {" "}
                                                              &{" "}
                                                              <strong>
                                                                {
                                                                  Case.otherAppellantCount
                                                                }{" "}
                                                                Ors
                                                              </strong>
                                                            </>
                                                          ) : (
                                                            ""
                                                          )}
                                                        </tr>
                                                        {/* <tr>{Case.appellants_title}</tr> */}
                                                      </td>
                                                      <td
                                                        style={{
                                                          whiteSpace: `normal`,
                                                          border: `1px solid black`,
                                                        }}
                                                      >
                                                        <tr>
                                                          {Case.respondent}
                                                          {Case.otherRespondentCount ===
                                                          1 ? (
                                                            <>
                                                              <strong>
                                                                {" "}
                                                                & Anor{" "}
                                                              </strong>
                                                            </>
                                                          ) : Case.otherRespondentCount >
                                                            1 ? (
                                                            <>
                                                              {" "}
                                                              &{" "}
                                                              <strong>
                                                                {
                                                                  Case.otherRespondentCount
                                                                }{" "}
                                                                Ors
                                                              </strong>
                                                            </>
                                                          ) : (
                                                            ""
                                                          )}
                                                        </tr>
                                                        {/* <tr>{Case.respondent_title}</tr> */}
                                                      </td>
                                                      <td
                                                        style={{
                                                          border:
                                                            "1px solid black",
                                                          wordBreak:
                                                            "break-word",
                                                          whiteSpace:
                                                            "pre-wrap",
                                                          maxWidth: "250px",
                                                        }}
                                                      >
                                                        <p>
                                                          {" "}
                                                          Reason:{" "}
                                                          {item.reason
                                                            ? item.reason
                                                            : "N/A"}{" "}
                                                        </p>
                                                        Remark:{" "}
                                                        {item.remark
                                                          ? item.remark
                                                          : "N/A"}
                                                      </td>
                                                      {(!hasSisters ||
                                                        index2 === 0) && (
                                                        <td
                                                          id="hideDate"
                                                          style={{
                                                            border: `1px solid black`,
                                                          }}
                                                        >
                                                          {/* <button className="btn btn-success" type="button" 
                                                                                        onClick={() => { setCaseDiaryId(Case.case_diary_id); 
                                                                                            setAttachReasonModal(true); }}
                                                                                        id="button-addon2"><span className='fa fa-edit'>Reason</span></button> */}
                                                          <button
                                                            className="btn btn-success"
                                                            type="button"
                                                            onClick={() => {
                                                              setCaseDiaryId(
                                                                Case.case_diary_id,
                                                              );
                                                              setReason(
                                                                item.reason ||
                                                                  "",
                                                              );
                                                              setRemark(
                                                                item.remark ||
                                                                  "",
                                                              );
                                                              setAttachReasonModal(
                                                                true,
                                                              );
                                                            }}
                                                          >
                                                            <span className="fa fa-edit">
                                                              Reason
                                                            </span>
                                                          </button>
                                                        </td>
                                                      )}
                                                    </>
                                                  ) : (
                                                    <>
                                                      {/* <td style={{ whiteSpace: `normal` }}>{Case.parties}</td> */}
                                                      <td
                                                        className="text-center"
                                                        style={{
                                                          whiteSpace: `normal`,
                                                          border: `1px solid black`,
                                                        }}
                                                      >
                                                        <tr>
                                                          {Case.appellants}
                                                          {Case.otherAppellantCount ===
                                                          1 ? (
                                                            <>
                                                              <strong>
                                                                {" "}
                                                                & Anor{" "}
                                                              </strong>
                                                            </>
                                                          ) : Case.otherAppellantCount >
                                                            1 ? (
                                                            <>
                                                              {" "}
                                                              &{" "}
                                                              <strong>
                                                                {
                                                                  Case.otherAppellantCount
                                                                }{" "}
                                                                Ors
                                                              </strong>
                                                            </>
                                                          ) : (
                                                            ""
                                                          )}
                                                        </tr>
                                                        {/* <tr>({Case.appellants_title})</tr> */}
                                                        <tr>
                                                          <div className="mt-2 mb-2">
                                                            VS.
                                                          </div>
                                                        </tr>
                                                        <tr>
                                                          {Case.respondent}
                                                          {Case.otherRespondentCount ===
                                                          1 ? (
                                                            <>
                                                              <strong>
                                                                {" "}
                                                                & Anor{" "}
                                                              </strong>
                                                            </>
                                                          ) : Case.otherRespondentCount >
                                                            1 ? (
                                                            <>
                                                              {" "}
                                                              &{" "}
                                                              <strong>
                                                                {
                                                                  Case.otherRespondentCount
                                                                }{" "}
                                                                Ors
                                                              </strong>
                                                            </>
                                                          ) : (
                                                            ""
                                                          )}
                                                        </tr>
                                                        {/* <tr>({Case.respondent_title})</tr> */}
                                                      </td>
                                                      {/* <td style={{ whiteSpace: `pre-wrap`, border: `1px solid black`, wordWrap: `break-word` }}>{Case.case_desc}</td> */}
                                                      {/* <td style={{ whiteSpace: `pre-wrap`, border: `1px solid black`, wordWrap: `break-word`}}>
                                                                                        {Case.caseDescriptions && Case.caseDescriptions.map((desc, descIndex) => ( <><br></br>
                                                                                            <tr style={{margin: '10px !important'}}>{descIndex + 1}. {desc?.description} </tr>
                                                                                        </>))}
                                                                                    </td> */}
                                                      <td
                                                        style={{
                                                          border:
                                                            "1px solid black",
                                                          wordBreak:
                                                            "break-word",
                                                          whiteSpace:
                                                            "pre-wrap",
                                                          maxWidth: "250px",
                                                        }}
                                                      >
                                                        <p>
                                                          Reason:{" "}
                                                          {item.reason
                                                            ? item.reason
                                                            : "N/A"}
                                                        </p>
                                                        Remark:{" "}
                                                        {item.remark
                                                          ? item.remark
                                                          : "N/A"}
                                                      </td>
                                                      {(!hasSisters ||
                                                        index2 === 0) && (
                                                        <td
                                                          id="hideDate"
                                                          style={{
                                                            border: `1px solid black`,
                                                          }}
                                                        >
                                                          {/* <button className="btn btn-success" type="button" 
                                                                                        onClick={() => { setCaseDiaryId(Case.case_diary_id); setAttachReasonModal(true); }} 
                                                                                        id="button-addon2"><span className='fa fa-edit'>Reason</span></button> */}
                                                          <button
                                                            className="btn btn-success"
                                                            type="button"
                                                            onClick={() => {
                                                              setCaseDiaryId(
                                                                Case.case_diary_id,
                                                              );
                                                              setReason(
                                                                item.reason ||
                                                                  "",
                                                              );
                                                              setRemark(
                                                                item.remark ||
                                                                  "",
                                                              );
                                                              setAttachReasonModal(
                                                                true,
                                                              );
                                                            }}
                                                          >
                                                            <span className="fa fa-edit">
                                                              Reason
                                                            </span>
                                                          </button>
                                                        </td>
                                                      )}
                                                    </>
                                                  )}
                                                </tr>
                                              );
                                            },
                                          )}
                                      </>
                                    ))}
                                  </tbody>
                                </table>
                              </div>
                            </div>
                          ))}
                      </div>
                    );
                  },
                )}
              </div>
            </div>
          )}

          {Object.entries(dailyCauseList).length > 0 && (
            <div className="col-md-12 hideBtn">
              <button
                className="btn btn-outline-primary"
                type="button"
                onClick={() => window.print()}
                id="button-addon2"
              >
                Print
              </button>
            </div>
          )}

          {/* attach ruling modal */}
          <Modal
            show={attachReasonModal}
            onHide={() => setAttachReasonModal(false)}
          >
            <Modal.Header closeButton>
              <Modal.Title>Attach Reason for Case Assignment </Modal.Title>
            </Modal.Header>
            <Modal.Body>
              <form onSubmit={handleReasonSubmit}>
                <Form.Group className="mb-3">
                  <Form.Label>Reason</Form.Label>
                  <Form.Control
                    as="select"
                    value={reason}
                    onChange={(e) => setReason(e.target.value)}
                  >
                    <option value="">Select...</option>
                    <option value="COURT">COURT</option>
                    <option value="OLD">OLD</option>
                    <option value="CJN">CJN</option>
                    <option value="ML">ML</option>
                    <option value="OTHER">OTHER</option>
                  </Form.Control>
                </Form.Group>

                <Form.Group className="mb-3">
                  <Form.Label>Remark/Comment</Form.Label>
                  <Form.Control
                    as="textarea"
                    rows={3}
                    value={remark}
                    onChange={(e) => setRemark(e.target.value)}
                  />
                </Form.Group>

                <div className="d-flex justify-content-end mt-3">
                  <Button
                    variant="danger"
                    onClick={() => {
                      setAttachReasonModal(false);
                      setReason("");
                      setRemark("");
                      setCaseDiaryId("");
                      // setCaseToAttachReason({ caseId: '', appealNo: '', adjournment_proof: '' })
                    }}
                  >
                    Cancel
                  </Button>
                  <Button
                    type="submit"
                    variant="success"
                    className="ms-2"
                    disabled={isLoading || !reason}
                  >
                    {isLoading ? "Saving..." : "Submit"}
                  </Button>
                </div>
              </form>
            </Modal.Body>
          </Modal>
          {/* end attach ruling modal */}
        </div>
      )}
    </>
  );
};

export default CauseListWithSisterReason;
